import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyD5BsP72b8gkd-pORBOQjRKYJsgQc_1SYA",
    authDomain: "timeless-puglia.firebaseapp.com",
    projectId: "timeless-puglia",
    storageBucket: "timeless-puglia.firebasestorage.app",
    messagingSenderId: "786171985078",
    appId: "1:786171985078:web:323c698a30b208e5733a17"
  };

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
